import {
  authSetup,
  envSetup,
  errorSetup,
  i18nSetup,
  titleSetup,
  navigationSetup
} from './libs';
import { isPluginMode } from '../utils/isPluginMode';

export const setupAllSteps = () => Promise.allSettled([
  authSetup(),
  !isPluginMode() && navigationSetup(),
  envSetup(),
  errorSetup(),
  i18nSetup(),
  titleSetup()
  ]).then((values) => {
    const obj = {}
    values.forEach(val => {
      if(val.status === 'fulfilled') {
        Object.assign(obj, {...val.value})
      }
    })

    return obj
  })

